<template>
  <sPopover
    :open-delay="300"
    placement="bottom-start"
    popper-class="created-in-old-account-tooltip tooltip pa-4 h8-text text-start"
    transition="s-zoom-in-top"
    trigger="hover">
    <sChip
      slot="reference"
      background="var(--color-main-green)"
      :class="[mode==='icon' ? 'px-1 icon-chip' : '', 'created-in-old-account-chip', chipClass]"
      color="var(--text-color)"
      data-qa="created-in-old-account-chip"
      :style="innerStyle">
      <div
        class="flex flex-wrap"
        :class="{'mx-1': mode !== 'icon', 'my-1': mode === 'top'}">
        <sIcon
          class="my-auto"
          size="13"
          type="alert-outline"/>
        <div
          v-if="mode !== 'icon'"
          class="ml-1 h7-text">
          {{ $t('Tenders.CreatedInOldAccount') }}
        </div>
      </div>
    </sChip>
    <div>
      {{ $t('Tenders.ToEditGoTo') }}
    </div>
    <a
      data-qa="href-to-old-cabinet"
      :href="href"
      style="text-decoration: underline !important"
      target="_blank"
      @click="sendStat">
      {{ $t('Tenders.OldPersonalAccount') }}
    </a>
  </sPopover>
</template>
<script>
import godModeMixin from 'mixins/godModeMixin'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

/**
 * Чипса перехода в старый кабинет
 */
export default {
  name: 'createdInOldAccountChip',
  mixins: [godModeMixin],
  props: {
    mode: {
      type: String,
      default: 'default',
      validator: function (value) {
        const correct = ['default', 'icon', 'top'].indexOf(value) !== -1
        return correct
      },
    },
    chipClass: String,
    innerStyle: String,
    tenderId: {
      type: [Number, String],
    }
  },
  methods: {
    /**
     * Сохраняем статистику перехода в старый кабинет
     */
    sendStat() {
      api.redirectToOldCabinet('EDIT')
    }
  },
  computed: {
    href() {
      return window.config?.SmarttenderUrl + `/webclient/?proj=IT_${this.$i18n.locale.toUpperCase()}&par3=%3BITCALL%2C%2FKEYMNU%3ADMZTEND%2FFUNCARGSTYPE%3AStartInfo%2FFUNCARGS%3A%7B%23034CustomProperties%23034%3A%7B%7D%2C%23034Editable%23034%3A${this.mixin_isGodMode}%2C%23034Krap%23034%3A%23034%23034%2C%23034HelpMode%23034%3Afalse%2C%23034FullScreenMode%23034%3Atrue%2C%23034Multi%23034%3Afalse%2C%23034AllowPartialDataOnMultiMode%23034%3Afalse%2C%23034PrimaryKeyFilter%23034%3A%7B%23034UNDOC%23034%3A${this.tenderId}%7D%2C%23034SkipFilterDialogs%23034%3Atrue%2C%23034DeveloperMode%23034%3A${this.mixin_isGodMode}%7D`
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-chip {
  height: 19px;
  min-width: 22px;
}
</style>
